import jwtDecode from 'jwt-decode';

import storedToken from './session-data/api-token';
import storedUserInfo from './session-data/user-info';

function getRemainingSessionTime(token) {
  if (!token) return 0;

  try {
    const { exp: expiryTime } = jwtDecode(token);
    const currentTime = Math.floor(Date.now() / 1000);
    return Math.max(expiryTime - currentTime, 0);
  } catch (e) {
    return 0;
  }
}

export function read() {
  const token = storedToken.get();
  const ttl = getRemainingSessionTime(token);

  if (!(token && ttl > 0)) return null;

  const user = storedUserInfo.get();

  // Note: The session user may be null, when a valid token is available,
  // but the user information has not yet been loaded from the API.

  return { user, ttl, token };
}

export function write(info) {
  const { token, user } = info || {};
  if (token) storedToken.set(token);
  if (user) storedUserInfo.set(user);
}

export function clear() {
  storedToken.clear();
  storedUserInfo.clear();
}
